<template>
    <div>
        <CForm>
            <CInput
                v-model="event.current_date_title"
                label="Дата мероприятия"
                placeholder="Введите дату мероприятия"
                required
            />

            <CRow>
                <CCol>
                    <CInput
                        v-model="newItem.time"
                        label="Время"
                        placeholder="Введите время"
                        @keyup.enter="addItem"
                    />
                </CCol>
                <CCol>
                    <CInput
                        v-model="newItem.text"
                        label="Подпись"
                        placeholder="Введите подпись"
                        @keyup.enter="addItem"
                    />
                </CCol>
            </CRow>
            <CButton color="primary" class="mb-3" @click="addItem">Добавить время</CButton>

            <ul>
                <li v-for="(item, index) in event.current_date_times" :key="index">
                    {{ item.time }} - {{ item.text }}
                    <CButton color="danger" size="sm" class="ml-2" @click="removeTime(index)">Удалить</CButton>
                </li>
            </ul>
        </CForm>
    </div>
</template>

<script>
import { CForm, CInput, CButton, CCol } from '@coreui/vue';

export default {
    name: 'AdsCampaignEventForm',
    components: {
        CForm,
        CInput,
        CButton,
    },
    props: {
        event: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            newItem: {
                time: '',
                text: ''
            },
        };
    },
    methods: {
        addItem() {
            if (this.newItem) {
                if (!this.event.current_date_times) {
                    this.event.current_date_times = [];
                }
                this.event.current_date_times.push(this.newItem);
                this.newItem = {
                    time: '',
                    text: ''
                };
            }
        },
        removeTime(index) {
            this.event.current_date_times.splice(index, 1);
        },
        save() {
            if (!this.event.current_date_title) {
                this.$root.$emit('showError', 'Введите дату мероприятия.');
                return;
            }
            this.$emit('save', this.event);
        },
    },
};
</script>
